module.exports = __webpack_public_path__ + "static/media/penyelenggara-sertifikat-elektronik.9fd08b9e.png";